import { CommunityMembers } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";

const CommunityMembersPage = () => {
    const [showMembers, setShowMembers] = useState(false);
    const [showAdmins, setShowAdmins] = useState(false);

    return (
        <FeedLayout pageTitle="profile">
            <CommunityMembers
                setShowMembers={setShowMembers}
                showAdmins={showAdmins}
                setShowAdmins={setShowAdmins}
                hideArrow
            />
        </FeedLayout>
    );
};

export default CommunityMembersPage;
